module.exports = __webpack_public_path__ + "static/img/3.7eeb6b91.png";